/* eslint-disable max-len */
export const NOT_UPDATE = "Chưa cập nhật";
export const IN_PROCESSING = "Đang xử lý";
export const WAIT_UPDATE = "Đang cập nhật";
export const NOT_EXIST = "Thông tin không tồn tại";
export const CHOOSE_GENDER = "Chọn giới tính";
export const CHOOSE_YEAR = "Chọn năm sinh";
export const MALE = "Nam";
export const FEMALE = "Nữ";
export const YES = "Có";
export const NO = "Không";
export const CLOSE = "Đóng";
export const OK = "Đồng ý";
export const REMOVE = "Xóa";
export const SEND = "Gửi";
export const CONFIRM = "Xác nhận";
export const MORNING = "Buổi sáng";
export const AFTERNOON = "Buổi chiều";
export const ALL_DAY = "Cả ngày";
export const NO_LONGER_DISPLAY = "Không hiển thị lần sau";
export const COOKIE_VIETINBANK = "cookieVietinBank";
export const WRONG_NUMBER = "Vui lòng nhập đúng số điện thoại!";
export const SEARCHING_MESSAGE_ERROR =
  " Rất tiếc! Không có kết quả nào trùng khớp với thông tin bạn tìm kiếm.";
export const FOREIGN_COUNTRY = "Nước ngoài";
export const VIET_NAM = "Việt Nam";
export const OTHER_NUMBER = "Số khác";
export const TITLE_CANCEL_MEDICAL_BILL = "Hủy phiếu khám này ?";
export const CONTENT_CANCEL_MEDICAL_BILL =
  "Bạn có chắc là muốn hủy phiếu khám này khỏi danh sách ?";
export const TITLE_RESEND_SMS = "Chọn số điện thoại nhận tin!";
export const SELECT_BOX_BHYT = [
  {
    id: -1,
    name: "Chọn bảo hiểm y tế"
  },
  {
    id: 1,
    name: "Có giấy chuyển BHYT đúng tuyến BV ĐHYD"
  },
  {
    id: 2,
    name: "Tái khám theo hẹn trên toa thuốc BHYT của BV ĐHYD"
  },
  {
    id: 0,
    name: "Không phải các trường hợp trên / Không có BHYT"
  }
];

export const MASK_MA_HO_SO_UMC = "***-9999999";

export const PLACEHOLDER_MA_HO_SO_UMC = "VD: N18-XXXXXXXX";
export const MASK_MA_THANH_TOAN_UMC = "999999aa-9999";
export const PLACEHOLDER_MA_THANH_TOAN_UMC = "VD: 180912TA-0345";

export const NOTI_TYPE = {
  1: "Lịch khám bệnh",
  2: "Lịch khám bệnh",
  3: "Sự kiện / khuyến mãi",
  4: "Hệ thống Medpro",
  5: "Hệ thống Medpro"
};

export const MAX_YEAR_OF_CHILD_UMC = 15;
export const MIN_YEAR_OF_OLD_PEOPLE_UMC = 60;

export const UMC_ERROR_MESSAGE_CHILD_CHICH_NGUA =
  "Trẻ em dưới 15 tuổi, vui lòng chọn chuyên khoa nhi.";

export const UMC_ERROR_MESSAGE_OLD_PEOPLE_LAO_KHOA =
  "Chuyên khoa Lão Khoa chỉ khám, chữa bệnh cho Bệnh nhân từ 60 tuổi trở lên.";

export const PLATFORM_NAME = "web";
export const WEB_NAME = "medpro";

export const DEFAULT_COUNTRY = { id: 222, code: "VN", name: "Việt Nam" };

export const ID_FEATURE_DAT_KHAM = "5ed0659c54bdb00019e4741a";
export const ID_FEATURE_DAT_KHAM_THEO_BAC_SI = "5f2274e060d7f71760004972";
export const ID_FEATURE_THANH_TOAN_VIEN_PHI = "5f0679e5672b040019c7d4d3";

export const FEATURE_TYPES = {
  bookingCovid: "booking.covid",
  bookingDate: "booking.date",
  bookingDoctor: "booking.doctor",
  paymentFee: "payment.fee",
  paymentFeeHistory: "payment.fee.history",
  examResultSearch: "payment.fee.search",
  _eInvoice: "payment.invoice",
  eInvoice: "e.invoice",
  khaiBaoYTe: "declare.yt",
  examresult: "exam.profile",
  bookingVaccine: "booking.vaccine",
  guidePatient: "instruc",
  bookingDoctorAll: "bookingDoctor.all",
  bookingXNC: "booking.xnc"
};

export const SERVICE_TYPE_INSURANCE = "INSURANCE_ONLY";
export const SERVICE_TYPE_NO_INSURANCE = "NO_INSURANCE_ONLY";
export const SERVICE_TYPE_BOTH = "BOTH";
export const CHECK_WITH_INSURANCE_CODE_EXIST =
  "CHECK_WITH_INSURANCE_CODE_EXIST";

export const BANNER_HOME_DESKTOP = "banner_desktop.png";
export const BANNER_HOME_MOBILE = "banner_mobile.png";
export const LOGO_HEADER_COLOR = "header_logo.svg";
export const LOGO_PNG = "logo.png";
export const LOGO_HEADER_WHITE = "logo_header_white.svg";
export const LOGO_FOOTER = "footer_logo.svg";
export const SLIDE = "slide.png";
export const IMG_MA_BENH_NHAN = "bien_lai.png";
export const IMG_MA_THANH_TOAN = "payment_bill.png";

export const SUBJECT = "subject";
export const SERVICE = "service";
export const ROOM = "room";
export const DOCTOR = "doctor";
export const MEDPRO = "medpro";
export const MOMO = "momo";
export const NHIDONG1 = "nhidong1";

// export const PAYMENT_HUB_URL_LOCAL = "http://localhost:9999";
// export const PAYMENT_HUB_URL_TESTING =
//   "https://payment-gateway-qrcode-testing.medpro.com.vn";

export const CSGroupID = 3;

export const REDIRECT_URL_AFTER_BOOKING = `${window.location.origin}/chi-tiet-phieu-kham-benh`;
export const REDIRECT_URL_AFTER_PAYMENT_FEE = `${window.location.origin}/ket-qua-thanh-toan-vien-phi`;
export const REDIRECT_URL_AFTER_PAYMENT_EXAM = `${window.location.origin}/phieu-kham-benh/chi-tiet/`;
export const GATEWAY_CHECK_STT_TRANSACTION =
  "https://payment-gateway.medpro.com.vn:1234/payment/v1/payin/getTransactionStatus";
export const GATEWAY_RECHECK_STT_TRANSACTION =
  "https://payment-gateway.medpro.com.vn:1234/payment/v1/payin/reCheckTransaction";

export const EXTEND_DATA_TEST =
  "000201010212262200069704360108530BYTQD5204806253037045405230005802VN5917BENH VIEN CHO RAY6003HCM62860120VP2012233H4RH7ZPGNHN0318BENH VIEN CHO RAY 07120520730003850820VP2012233H4RH7ZPGNHN6304AD57";

// 18-1 -> 18/2
export const NOTI =
  "Từ ngày 18.1.2021 đến hết ngày 18.2.2021 ứng dụng miễn phí tiện ích người dùng 10.000 VNĐ trên 1 phiếu đặt đặt khám. Trân trọng!";

export const ROUTE_WITHOUT_HEADER = [
  "/iframeMomoTesting",
  "/medicalDetailByUser",
  "/login"
];

export const patternMobile = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
export const patternPhone = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;

export const handleAge = partnerId => {
  let _ageChildren = 0;
  let _ageJunior = 0;
  switch (partnerId) {
    case "nhidong1":
      _ageChildren = 16;
      _ageJunior = 16;
      break;

    case "nhidonghcm":
      _ageChildren = 18;
      _ageJunior = 18;
      break;

    default:
      _ageChildren = 6;
      _ageJunior = 16;
      break;
  }
  return { _ageChildren, _ageJunior };
};

export const IOS_MEPRO = "https://apps.apple.com/us/app/id1481561748";
export const Android_MEDPRO =
  "https://play.google.com/store/apps/details?id=vn.com.medpro";

export const urlPage = {
  CSKH: "/cham-soc-khach-hang",
  Chon_Benh_Vien: "/chon-benh-vien",
  Chon_Ho_So: "/chon-ho-so",
  Xac_Nhan_Thong_Tin: "/xac-nhan-thong-tin"
};

export const TypeAction = {
  DaTungKham: "DaTungKham",
  ChuaTungKham: "ChuaTungKham",
  SuaHoSo: "SuaHoSo",
  ThemLaiHoSo: "ThemLaiHoSo",
  DatKham: "DatKham",
  ChiTietPhieu: "ChiTietPhieu",
  HuyPhieu: "HuyPhieu",
  SuaPhieuKham: "SuaPhieuKham",
  TrangChu: "/",
  ChonBenhVien: "/chon-benh-vien",
  ChonHinhThucDatKham: "/chon-hinh-thuc-dat-kham",
  ChonHoSo: "/chon-ho-so",
  ChonDichVu: "/chon-dich-vu",
  ChonChuyenKhoa: "/chon-chuyen-khoa",
  ChonBacSi: "/chon-bac-si",
  ChonLichKham: "/chon-lich-kham",
  XacNhanThongTin: "/xac-nhan-thong-tin",
  HinhThucThanhToan: "/hinh-thuc-thanh-toan",
  ThanhToanHo: "/thanh-toan-ho",
  TraCuuHoaDonDienTu: "/tra-cuu-hoa-don-dien-tu",
  HuongDanBenhNhan: "/huong-dan-benh-nhan",
  TimMaThanhToanVienPhi: "/tim-ma-thanh-toan-vien-phi",
  // TraCuuKetQuaKhamBenh: "/tra-ket-qua-kham-benh",
  TraKetQuaKhamBenh: "/tra-ket-qua-kham-benh"
};

export const HospitalStepOnePatient = ["umc"];
export const listAppId = ["medpro", "momo", "vnptpay", "cskh"];
export const partnerAppId = ["momo", "vnptpay"];

export const BOOKING_STATUS = {
  DA_HUY: -2,
  DA_THANH_TOAN: 1,
  DA_KHAM: 2,
  CHUA_THANH_TOAN: 0,
  THANH_TOAN_HO: 6
};
export const partnerFilterCheck = ["umc2"];
